<script>
import CommentEdit from '@/components/CommentEdit.vue'
import emitter from '@/modules/events/emitter'
import Swal from 'sweetalert2'
import { $axios } from '@/modules/http/axios'
import eventKinds from '@/modules/events/eventKinds'

export default {
  name: 'ShowDriverCommentModal',
  components: { CommentEdit },
  data () {
    return {
      driver: null
    }
  },
  created () {
    emitter.on('driverCommentModalRequested', e => {
      this.driver = e.driver
      this.reFetchComments()
    })
    emitter.on(eventKinds.vehiclesPolled, this.reFetchComments)
    emitter.on(eventKinds.driverCommentDeleted, this.reFetchComments)
  },
  methods: {
    handleNewLine (str) {
      return str.replace(/(?:\r\n|\r|\n)/g, '<br />')
    },

    async deleteComment (id) {
      try {
        await $axios.delete(`Comment/${id}`)
        await this.reFetchComments()
        await Swal.fire({
          title: 'Komentarz usunięty',
          text: 'Komentarz został usunięty',
          icon: 'success',
          confirmButtonText: 'OK'
        })
      } catch (e) {
        await Swal.fire({
          title: 'Błąd podczas usuwania komentarza',
          text: '',
          icon: 'error'
        })
      }
    },
    async reFetchComments () {
      if (this.driver) {
        this.driver.comments = (await $axios.get(`Driver/${this.driver.id}`)).data.comments
      }
    }
  }
}
</script>

<template>
  <div class="modal fade mt-5" id="driverCommentModal" tabindex="-1" aria-labelledby="driverCommentModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="driverCommentModalLabel">
            Podgląd komentarzy dla kierowcy: <span v-if="driver">{{ driver.firstName }} {{ driver.surname }}</span>
          </h5>
          <button id="driver-comment-modal-close-btn" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="driver = null"></button>
        </div>
        <div class="modal-body" v-if="driver">
          <div v-for="(comment, i) in driver.comments" :key="comment.id">
            <div
              class="p-1 rounded mb-2"
              :style="`background-color: ${comment.backgroundColor ?? '#ffffff'}; color: ${comment.textColor ?? '#000000'};`">
              <h6>
                {{ comment.title }}
              </h6>
              <p v-html="handleNewLine(comment.content)"></p>
            </div>
            <div class="d-flex justify-content-between" :key="comment.id">
              <CommentEdit
                :key="comment.id"
                :comment="comment"
                style="float: left; text-align: center;"
              />
              <button class="btn btn-danger" @click="deleteComment(comment.id)">
                Usuń komentarz
              </button>
            </div>
            <hr v-show="i < driver.comments.length - 1">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
